module.exports = __webpack_public_path__ + "static/media/ic-caret-down-fill2.e789e760.svg";